import { render, staticRenderFns } from "./TMenuComboboxOptionItem.vue?vue&type=template&id=a8da6f42&scoped=true&"
import script from "./TMenuComboboxOptionItem.vue?vue&type=script&lang=js&"
export * from "./TMenuComboboxOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./TMenuComboboxOptionItem.vue?vue&type=style&index=0&id=a8da6f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da6f42",
  null
  
)

export default component.exports